import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

import classes from "./classes.module.scss";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import ContributorBadge from "components/pages/ProfessionalSpace/components/ContributorBadge";

type IProps = {
	contributor: ContributorResponseResource;
	avatar: string;
};

export default function ProjectLeader(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Typography type="p" weight="medium" size="small">
				{I18n.trslt(I18n.asset.pages.project.project_leader)}
			</Typography>
			<ContributorBadge avatarUrl={props.avatar} contributor={props.contributor} />
		</div>
	);
}
